import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/ui/select'

export type BillingPeriod = 'monthly' | 'yearly'

interface BillingPeriodSelectProps {
  value?: BillingPeriod
  onValueChange: (value: BillingPeriod) => void
  className?: string
  placeholder?: string
  defaultValue?: BillingPeriod
}

export function BillingPeriodSelect({
  value,
  onValueChange,
  className,
  placeholder = 'Select billing period',
  defaultValue = 'monthly',
}: BillingPeriodSelectProps) {
  return (
    <Select value={value || defaultValue} onValueChange={onValueChange}>
      <SelectTrigger className={className}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value='monthly'>Monthly</SelectItem>
        <SelectItem value='yearly'>Annually</SelectItem>
      </SelectContent>
    </Select>
  )
}
